var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"vis-box-container"},[_c('div',{ref:"visContainer",staticClass:"vis-box"}),_c('showDetail',{ref:"showDetail",attrs:{"detail":_vm.detail},on:{"close":function($event){_vm.detail = null}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }